<div
  id="main"
  class="overflow-hidden"
>
  <div
    class="w-full overflow-y-scroll"
    [@fade]
  >
    <div class="w-full">
      <app-header-bar></app-header-bar>
    </div>
    <div class="mt-36">
      <router-outlet (activate)="onActivate($event)"></router-outlet>
    </div>
    <div>
      <app-footer></app-footer>
    </div>
    <app-cookie-banner></app-cookie-banner>
  </div>
</div>
